import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import OtpAttempt from 'app/OtpAttempt';
import { useContext } from './useFormContext';
import { UpdateValidationState } from './useValidationState';

type TwofaProps = { updateValidationState: UpdateValidationState };

const isAttemptValid = (otpAttempt: string) => /\d{6}/.test(otpAttempt);

const useTwofa = (updateValidationState: UpdateValidationState) => {
  const [otpAttempt, setOtpAttempt] = useState('');
  const [isOtpAttemptValid, setIsOtpAttemptValid] = useState(false);

  const changeOtpAttempt = (v: string) => {
    setOtpAttempt(v);
    const isValid = isAttemptValid(v);
    setIsOtpAttemptValid(isValid);
    updateValidationState({ field: 'otpAttempt', isValid });
  };

  useEffect(() => {
    changeOtpAttempt('');
  }, []);

  return [otpAttempt, isOtpAttemptValid, changeOtpAttempt] as const;
};

const Twofa: FC<TwofaProps> = ({ updateValidationState }) => {
  const {
    twofa: { verify },
    locales,
  } = useContext();

  if (!verify) return null;

  const [otpAttempt, isOtpAttemptValid, changeOtpAttempt] = useTwofa(updateValidationState);

  return (
    <div className="rs-column-small-12 rs-text-align_center twofa-verification">
      <div className="alert">
        <div className="rs-text-size_small">{locales.enter_otp}</div>
        <OtpAttempt otpAttempt={otpAttempt} setOtpAttempt={changeOtpAttempt} error={!isOtpAttemptValid} />
        <label className="checkbox pt_label__check remember">
          <input type="checkbox" name="otp_remember" className="pt_checkbox_box" />
          <span className="pt_checkbox_text">{locales.remember_otp}</span>
        </label>
      </div>
    </div>
  );
};

export default Twofa;
